import React, { useEffect, useState } from 'react';
// material-ui
import { Typography } from '@mui/material';

// project imports
import NavGroup from './NavGroup';
import menuItem from '../../../../menuItems';
import { useSelector } from 'react-redux';
import useRouteGuard from '../../../../hooks/useRouteGuard';
import { CUSTOMERS } from '../../../../constants';
// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
  const { getIsReadOnlyPermission } = useRouteGuard();
  const { userPermissions } = useSelector((state) => state.common);
  const [filteredMenuList, setFilteredMenuList] = useState({});
  const collapseMenuRemove = (children) => {
    let filteredItem = [];
    children.filter((myItem) => {
      if (getIsReadOnlyPermission(myItem?.featureName)) {
        //Added User Setup if Role = 'Administrator'
        if (
          myItem.id !== 'AdminScreenRoles' &&
          myItem.id !== 'ETrackUserMCNMapping'
        ) {
          filteredItem.push(myItem);
        }
      } else if (getIsReadOnlyPermission(myItem?.featureName) === undefined) {
        if (
          (myItem.id === 'AdminScreenRoles' ||
            myItem.id === 'ETrackUserMCNMapping') &&
          userPermissions?.userAuthorizations[0]?.roleName ===
            CUSTOMERS.administratorRole
        ) {
          filteredItem.push(myItem);
        }
      }
    });
    return filteredItem;
  };
  //Hide menu if child is 0
  useEffect(() => {
    if (userPermissions !== null) {
      let copyMenuForFilter = structuredClone(menuItem);
      let filteredMenuList = copyMenuForFilter?.items?.filter((groupItem) => {
        groupItem.children.filter((subChild) => {
          subChild.children = collapseMenuRemove(subChild.children);
          return subChild;
        });
        return groupItem;
      });
      setFilteredMenuList({ items: filteredMenuList });
    }
  }, [userPermissions]);

  const navItems = filteredMenuList?.items?.map((item) => {
    switch (item.type) {
      case 'group':
        return (
          item?.children[0].children?.length > 0 && (
            <NavGroup key={item.id} item={item} />
          )
        );
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });
  return navItems;
};

export default MenuList;
